import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  BasicAuthInterceptor,
  DevPrivacyStateService,
  PrivacyStateService,
  ProdPrivacyStateService,
  SharedModule,
} from '@immosky/shared';
import { StoreModule } from '@ngrx/store';
import { AppParametersService, ENV } from '@immosky/types';
import { SearchSubscriptionAppParametersService } from './services/search-subscription-app-parameters.service';
import { environment } from '../environments/environment';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ObjectSearchFilterModule } from '@immosky/object-search-filter';
import { EffectsModule } from '@ngrx/effects';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MobileStepOneComponent } from './components/mobile-step-one/mobile-step-one.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { createCustomElement } from '@angular/elements';
import { StepperComponent } from './components/stepper/stepper.component';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { MobileStepTwoComponent } from './components/mobile-step-two/mobile-step-two.component';
import { DesktopStepOneComponent } from './components/desktop-step-one/desktop-step-one.component';
import { DesktopStepTwoComponent } from './components/desktop-step-two/desktop-step-two.component';
import { DesktopStepThreeComponent } from './components/desktop-step-three/desktop-step-three.component';
import { MobileWizardComponent } from './components/mobile-wizard/mobile-wizard.component';
import { DesktopWizardComponent } from './components/desktop-wizard/desktop-wizard.component';

@NgModule({
  declarations: [
    AppComponent,
    MobileStepOneComponent,
    StepperComponent,
    MobileStepTwoComponent,
    DesktopStepOneComponent,
    DesktopStepTwoComponent,
    DesktopStepThreeComponent,
    MobileWizardComponent,
    DesktopWizardComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    EffectsModule.forRoot(),
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: false,
        },
      }
    ),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
    ObjectSearchFilterModule,
    SharedModule,
    OverlayModule,
    CdkStepperModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicAuthInterceptor,
      multi: true,
    },
    {
      provide: AppParametersService,
      useClass: SearchSubscriptionAppParametersService,
    },
    {
      provide: ENV,
      useValue: environment,
    },
    {
      provide: PrivacyStateService,
      useFactory: () => {
        if (environment.production) {
          return new ProdPrivacyStateService();
        } else {
          return new DevPrivacyStateService();
        }
      },
    },
  ],
  exports: [AppComponent],
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    const customElement = createCustomElement(AppComponent, {
      injector: this.injector,
    });
    customElements.define('search-subscription', customElement);
  }
}
